import { Hero } from '@/components/PolicyTwo/Hero';
import { PolicyTwoPageContent } from '@/components/PolicyTwo/PolicyTwoPageContent';
import { Section } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/policyTwo';
import { DocumentTypes } from 'contentlayer/generated';
import React from 'react';

interface TransparencyPageProps {
  config: Config;
}
export const PolicyTwoPageTemplate: React.FC<TransparencyPageProps> = ({ config }) => {
  useShowHeaderCtaOnScroll(true);

  return (
    <>
      <SEO {...config.seo} />
      <Layout pt={[40, 70]} {...config.layout}>
        <Hero {...config.hero} />
        <Section darkBackground pt={[0, 80]} px="20px">
          <PolicyTwoPageContent content={config.MDXContent as DocumentTypes} />
        </Section>
      </Layout>
    </>
  );
};
